import React from "react";
import {
  List,
  Datagrid,
  ShowButton,
  TextField,
  ReferenceInput,
  ReferenceField,
  FunctionField,
  CardActions,
  RefreshButton,
  CreateButton,
  Filter,
  SelectInput,
  TextInput,
  EditButton,
  Pagination,
} from "react-admin";
import { withStyles } from "@material-ui/core/styles";
import { idStatusToText } from "../lib/kioskPresentation";
import {
  hasActionsRights,
  hasStartStopAllRights,
  hasKioskCreateRights,
} from "../lib/permissions";

import KioskBulkActionButtons from "./kioskBulkActionButtons";
import StartAllButton from "./startAllButton";
import PauseAllButton from "./pauseAllButton";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />
);

const KioskActions = ({ permissions, basePath }) => (
  <CardActions>
    {hasKioskCreateRights(permissions) && <CreateButton basePath={basePath} />}
    {hasStartStopAllRights(permissions) && <StartAllButton />}
    {hasStartStopAllRights(permissions) && <PauseAllButton />}
    <RefreshButton />
  </CardActions>
);

const KioskFilterByStation = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Station"
      source="stationid"
      reference="stations"
      allowEmpty
      filterToQuery={(searchText) => ({
        location: { like: `.*${searchText}.*`, options: "i" },
      })}
      alwaysOn
    >
      <SelectInput optionText="location" />
    </ReferenceInput>
  </Filter>
);

const KioskFilterByTitle = (props) => (
  <Filter {...props}>
    <TextInput label="Title" source="title" alwaysOn />
  </Filter>
);

const KioskList = ({ classes, permissions, ...props }) => (
  <List
    actions={<KioskActions permissions={permissions} />}
    bulkActionButtons={
      hasActionsRights(permissions) ? (
        <KioskBulkActionButtons {...props} />
      ) : null
    }
    title="Liste des bornes"
    filters={
      permissions === "super_admin" ? (
        <KioskFilterByStation />
      ) : (
        <KioskFilterByTitle />
      )
    }
    {...props}
    perPage={25}
    pagination={<PostPagination />}
  >
    <Datagrid>
      <TextField source="serialno" label="BorneId" />
      <TextField source="title" label="Nom" />
      {(permissions === "super_admin" || permissions === "station_user") && (
        <ReferenceField
          label="Station"
          source="stationid"
          reference="stations"
          linkType="show"
        >
          <TextField source="location" />
        </ReferenceField>
      )}
      <FunctionField
        label="Statut"
        source="status"
        render={(record) =>
          idStatusToText(classes, record.status, record.alertstatus)
        }
      />
      <ShowButton />
      {permissions === "super_admin" && <EditButton />}
    </Datagrid>
  </List>
);

const chip = {
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 10,
  paddingRight: 10,
  borderRadius: 10,
};

const styles = () => ({
  selling: { ...chip, backgroundColor: "rgba(0, 255, 0, 0.3)" },
  pause: { ...chip, backgroundColor: "rgba(0, 0, 255, 0.3)" },
  errorFatal: { ...chip, backgroundColor: "rgba(255, 0, 0, 0.3)" },
  errorNonFatal: { ...chip, backgroundColor: "rgba(235, 150, 5, 0.3)" },
  offline: { ...chip, backgroundColor: "rgba(255, 0, 0, 0.6)" },
  unknown: { ...chip, backgroundColor: "rgba(255, 150, 0, 0.3)" },
  buttonContainer: {
    marginTop: 5,
  },
});

export default withStyles(styles)(KioskList);



// WEBPACK FOOTER //
// ./src/components/kioskList.js